package com.anjuros.website.templates.selection.styles

import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.util.Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh

val CompanyColorVar by StyleVariable<CSSColorValue>()

val TemplateColumnWidthStyle = CssStyle {
    base { Modifier.fillMaxWidth(90.percent).margin(top = 75.px) }
    Breakpoint.MD { Modifier.fillMaxWidth(80.percent).margin(top = 75.px) }
    Breakpoint.LG { Modifier.fillMaxWidth(80.percent).margin(top = 100.px) }
    Breakpoint.XL { Modifier.fillMaxWidth(80.percent).margin(top = 100.px)}
}

val SuccessColumnWidthStyle = CssStyle {
    base { Modifier.maxWidth(250.px) }
    Breakpoint.MD { Modifier.maxWidth(250.px) }
    Breakpoint.LG { Modifier.maxWidth(350.px) }
    Breakpoint.XL { Modifier.maxWidth(350.px)}
}

val SuccessFontStyle = CssStyle {
    base { Modifier.fontSize(18.px)}
    Breakpoint.MD { Modifier.fontSize(18.px) }
    Breakpoint.LG { Modifier.fontSize(20.px) }
    Breakpoint.XL { Modifier.fontSize(20.px)}
}

val MainButtonStyle = CssStyle {
    base {
        Modifier
            .width(120.px)
            .transition(Transition.of("width", 200.ms))
    }
    hover {
        Modifier
            .width(140.px)
    }
}

val InputStyle = CssStyle {
    base {
        Modifier
            .styleModifier {
                property("--bs-border-color",Theme.LightGray.rgb)
                property("--bs-border-width",2.px)
            }
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = Theme.LightGray.rgb
            )
            .transition(Transition.of(property = "border", duration = 200.ms))
    }
    focus {
        Modifier
            .styleModifier {
                property("--bs-border-color", CompanyColorVar.value())
                property("--bs-border-width",2.px)

            }
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color = CompanyColorVar.value()
            )

    }

    hover {
        Modifier
            .styleModifier {
                property("--bs-border-color", CompanyColorVar.value())
                property("--bs-border-width",2.px)

            }
            .border(
                width = 2.px,
                style = LineStyle.Solid,
                color =  CompanyColorVar.value()
            )

    }
}

val NavigationFooterItemStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .transition(Transition.of(property = "color", duration = 200.ms))
    }
    hover {
        Modifier
            .color(Theme.Primary.rgb)
    }
}

val FooterTextStyle = CssStyle {
    base { Modifier.fontSize(20.px).color(Colors.White)
        .transition(Transition.of(property = "color", duration = 200.ms)) }
    Breakpoint.MD {  Modifier.fontSize(16.px) }
    Breakpoint.LG {Modifier.fontSize(20.px) }
    Breakpoint.XL { Modifier.fontSize(20.px)}

    hover {
        Modifier
            .color(Theme.Primary.rgb)
    }
}

val FooterCopyrightTextStyle = CssStyle {
    base { Modifier .fontSize(12.px) }
    Breakpoint.MD {  Modifier .fontSize(10.px) }
    Breakpoint.LG {Modifier .fontSize(12.px) }
    Breakpoint.XL { Modifier .fontSize(12.px)}
}

val SeeAllButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .color(Color("#1d3557"))
            .padding(topBottom = 12.px, leftRight = 32.px)
            .borderRadius(20.px)
            .border(2.px, LineStyle.Solid, Color("#1d3557"))
            .fontWeight(FontWeight.Bold)
            .cursor(Cursor.Pointer)
            // Fixed using your function signature:
            // offsetX, offsetY, blur, spread, color, inset
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 20.px,
                spreadRadius = 5.px,
                color = rgba(29, 53, 87, 0.15)
            )
            .transition(Transition.of("all", 300.ms))
    }

    hover {
        Modifier
            .backgroundColor(Color("#1d3557"))
            .color(Colors.White)
            .transform { translateY((-2).px) }
            // Increased glow on hover
            .boxShadow(
                offsetX = 0.px,
                offsetY = 8.px,
                blurRadius = 25.px,
                spreadRadius = 10.px,
                color = rgba(29, 53, 87, 0.25)
            )
    }
}

val SeeAllButtonSmallStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .color(Color("#1d3557"))
            .padding(topBottom = 4.px, leftRight = 16.px)
            .borderRadius(20.px)
            .border(2.px, LineStyle.Solid, Color("#1d3557"))
            .fontWeight(FontWeight.Bold)
            .cursor(Cursor.Pointer)
            // Fixed using your function signature:
            // offsetX, offsetY, blur, spread, color, inset
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 20.px,
                spreadRadius = 5.px,
                color = rgba(29, 53, 87, 0.15)
            )
            .transition(Transition.of("all", 300.ms))
    }

    hover {
        Modifier
            .backgroundColor(Color("#1d3557"))
            .color(Colors.White)
            .transform { translateY((-2).px) }
            .border(2.px, LineStyle.Solid, Color("#ffffff"))
            // Increased glow on hover
            .boxShadow(
                offsetX = 0.px,
                offsetY = 8.px,
                blurRadius = 25.px,
                spreadRadius = 10.px,
                color = rgba(29, 53, 87, 0.25)
            )
    }
}

val Header1CenterStyle = CssStyle {
    base { Modifier.fontSize(28.px) .fillMaxWidth(90.percent).margin(top=40.px).textAlign(
        TextAlign.Center) }
    Breakpoint.MD { Modifier.fontSize(28.px)   .fillMaxWidth(90.percent).margin(top=40.px).textAlign(
        TextAlign.Center) }
    Breakpoint.LG { Modifier.fontSize(38.px)   .fillMaxWidth(80.percent).margin(top=100.px).textAlign(
        TextAlign.Center) }
    Breakpoint.XL { Modifier.fontSize(38.px)   .fillMaxWidth(80.percent).margin(top=100.px).textAlign(
        TextAlign.Center)}
}

val Header2Style = CssStyle {
    base { Modifier.fontSize(26.px) }
    Breakpoint.MD { Modifier.fontSize(26.px) }
    Breakpoint.LG { Modifier.fontSize(36.px) }
    Breakpoint.XL { Modifier   .fontSize(36.px)}
}

val MainSubtitleTextAlign = CssStyle {
    base { Modifier.textAlign(TextAlign.Start) }
    Breakpoint.MD { Modifier.textAlign(TextAlign.Start) }
    Breakpoint.LG { Modifier.textAlign(TextAlign.Center) }
    Breakpoint.XL { Modifier.textAlign(TextAlign.Center)}
}

/** Leaves room for the fixed template toolbar (TemplateToolbar, 60px on every screen size). */
val HeaderHeight = CssStyle.base { Modifier.margin(top = 60.px) }

val BuilderWidthStyle = CssStyle {
    base { Modifier.padding(10.px) }
    Breakpoint.MD { Modifier.padding(10.px) }
    Breakpoint.LG { Modifier.padding(20.px) }
    Breakpoint.XL { Modifier.padding(20.px)}
}

val BlogH2Style = CssStyle {
    base { Modifier.fontSize(28.px)
    }
    Breakpoint.MD { Modifier.fontSize(34.px)}
    Breakpoint.LG { Modifier.fontSize(34.px)}
    Breakpoint.XL { Modifier.fontSize(34.px)
    }
}

val BlogGraphicStyle = CssStyle {
    base { Modifier.fillMaxWidth(95.percent) }
    Breakpoint.MD { Modifier.fillMaxWidth(95.percent) }
    Breakpoint.LG { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.XL { Modifier.fillMaxWidth(80.percent)}
}
